// src/AnimationView/functions/characters.ts
import { getEngine } from './engineManager';

/**
 * Retourne l'angle actuel du personnage, sous forme de Promise<number>.
 */
export async function getCurrentAngle(id: string | number): Promise<number> {
    const engine = getEngine();
    const idStr = String(id);
    const char = engine?.getCharacter(idStr);
    if (!char) {
        console.warn(`Character with id ${idStr} not found.`);
        return 0; // Retourne un angle par défaut
    }
    return char.getAngleDirection();
}

/**
 * Tourne le personnage, fonction async Promise<void>.
 */
export async function turnCharacter(
    id: string | number,
    direction: string,
    angle: number
): Promise<void> {
    const engine = getEngine();
    const idStr = String(id);
    const char = engine?.getCharacter(idStr);
    if (!char) {
        console.warn(`Character with id ${idStr} not found.`);
        return;
    }

    if (direction === 'RIGHT') {
        char.addAngle(-angle); // Tourner à droite
    } else if (direction === 'LEFT') {
        char.addAngle(angle); // Tourner à gauche
    } else if (direction === 'BACKWARD') {
        char.flipAngle();
    } else {
        // Si "direction" n'est pas reconnu, on fixe carrément l'angle
        char.setAngleDirection(angle);
    }
}

/**
 * Fait marcher le personnage d'une certaine distance.
 */
export async function walkCharacter(id: string | number, distance: number): Promise<void> {
    const engine = getEngine();
    const idStr = String(id);
    const char = engine?.getCharacter(idStr);
    if (!char) {
        console.warn(`Character with id ${idStr} not found.`);
        return;
    }
    await char.walk(distance);
}


/**
 * Fait sauter le personnage.
 */
export async function jumpCharacter(id: string | number, distance: number): Promise<void> {
    const engine = getEngine();
    const idStr = String(id);
    const char = engine?.getCharacter(idStr);
    if (!char) {
        console.warn(`Character with id ${idStr} not found.`);
        return;
    }
    console.log("jump")
    await char.jump(distance);
}
